export default __webpack_public_path__ + "8177aac9ceef2f04c0b8c59491b57e89.png";